<template>
  <v-container class="cmp-product_groups-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedProduct_groupDetails &&
              selectedProduct_groupDetails.product_group &&
              selectedProduct_groupDetails.product_group.product_group_name1
            "
          >
            <span
              v-if="
                selectedProduct_groupDetails &&
                selectedProduct_groupDetails.product_group
              "
              >{{
                selectedProduct_groupDetails.product_group
                  .product_group_name1 || $t("product_group_name")
              }}</span
            >
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div
                v-if="
                  selectedProduct_groupDetails &&
                  selectedProduct_groupDetails.product_group
                "
              >
                {{
                  selectedProduct_groupDetails.product_group
                    .product_group_name2 || $t("altername_name")
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <glayout
        :tabs="product_groupSidewindowTabs"
        :options="tabBtn"
        :loading="
          selectedProduct_groupDetails && selectedProduct_groupDetails.loading
        "
        @optionClicked="onTabOptionClicked"
      >
        <gtab>
          <grow>
            <gcol f="0.5">
              <gbox :title="$t('product_group')" h="132">
                <ProductInfo
                  :selectedProduct_groupDetails="selectedProduct_groupDetails"
                  @changed="onChanged"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProduct_groupDetails &&
                      selectedProduct_groupDetails.products &&
                      selectedProduct_groupDetails.products.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    max: 20,
                    min: 1,
                  })
                "
                :title="$t('related_products')"
              >
                <RelatedProduct
                  :selectedProduct_groupDetails="selectedProduct_groupDetails"
                  @add_click="onAddProductsClick"
                  @deleted="onProductsDeleted"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <ModalContainer :modalKey="'addProducts'" :width="'medium'">
      <AddProducts
        @cancelled="onDialogCancelled"
        :selectedProduct_groupDetails="selectedProduct_groupDetails"
        @added="onAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'importProducts'" :width="'medium'">
      <FileUploader
        @cancelled="onDialogCancelled"
        :allowedType="['xlsx', 'csv']"
        @upload="onUpload"
        @added="onAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'showUnmatchedLine'" :width="'small'">
      <unmatchedLineModal
        @cancelled="onDialogCancelled"
        :unmatchedLines="unmatchedLines"
      />
    </ModalContainer>
    <ModalContainer
      v-if="selectedProduct_groupDetails.display_pg_print_delivery_notes_btn"
      :modalKey="'printDeliveryNoteModal'"
      :width="'small'"
    >
      <printDeliveryModal
        @cancelled="onDialogCancelled"
        :templateArray="selectedProduct_groupDetails.templates"
        @onPrintDelivery="onPrintDelivery"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'documentTemplates'" :width="'small'">
      <DocumentTemplates @cancelled="onDialogCancelled" />
    </ModalContainer>
    <ModalContainer :modalKey="'productExport'" :width="'small'">
      <ProductExport @cancelled="onDialogCancelled" />
    </ModalContainer>
  </v-container>
</template>

<script>
import { checkTabListPermission } from "../../../../router/guard";
import { productGroupsLDTRoutes } from "../../router/routes";
import { CatalogStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import BoxWidget from "@plugins/box-widget/box-widget";
import ProductInfo from "./product_info";
import RelatedProduct from "./related-product";
import ModalContainer from "@dtplugins/modal/modal-container";
import AddProducts from "./add-products";
import DocumentTemplates from "./document-templates";
import ProductExport from "./product-export";
import { product_groupsCatalogGetters } from "../../store/product_groups/getters";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { product_groupsCatalogActions } from "../../store/product_groups/actions";
import {
  createModalMixin,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import FileUploader from "../../../../dt-plugins/dfile-uploader/file-uploader.vue";
import unmatchedLineModal from "./unmatched-line-modal.vue";
import printDeliveryModal from "./print-delivery-modal.vue";
import { ProductGroupsService } from "../../services/product-groups.service";
import {
  MHTTPCL,
  createHttpGetOptions,
} from "../../../../services/http/http-client";
import { ACCOUNTING_URL } from "../../../../services/common-urls";

export const moduleRoute = "catalog";
export const submenuRoute = "product_groups";

export default {
  components: {
    BoxWidget,
    ProductInfo,
    RelatedProduct,
    ModalContainer,
    AddProducts,
    DocumentTemplates,
    ProductExport,
    FileUploader,
    unmatchedLineModal,
    printDeliveryModal,
  },
  data() {
    return {
      active: -1,
      unmatchedLines: [],
      lockLoading: false,
    };
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("addProducts"),
    createModalMixin("importProducts"),
    createModalMixin("documentTemplates"),
    createModalMixin("productExport"),
    createModalMixin("showUnmatchedLine"),
    createModalMixin("printDeliveryNoteModal"),
  ],
  computed: {
    ...mapGetterObject(storeNS, product_groupsCatalogGetters),

    tabBtn: function () {
      const btnList = [
        {
          text: this.$t("product_import"),
          value: "product_import",
        },
        {
          text: this.$t("documents"),
          value: "documents",
        },
        {
          text: this.$t("product_export"),
          value: "product_export",
        },
      ];

      if (
        this.selectedProduct_groupDetails.display_pg_print_delivery_notes_btn
      ) {
        return [
          {
            text: this.$t("print_delivery_notes"),
            value: "print_delivery_note",
          },
          ...btnList,
        ];
      }

      return btnList;
    },
    selectedProduct_groupDetails: function () {
      const product_groupDetails =
        this.product_groupDetails?.[this.product_group_id] || {};

      const product_group = product_groupDetails.product_group || {};

      const display_pg_print_delivery_notes_btn =
        product_groupDetails.display_pg_print_delivery_notes_btn || false;

      const templates = product_groupDetails.templates || [];

      console.log("Meeee", product_groupDetails);

      return {
        ...product_groupDetails,
        product_group,
        display_pg_print_delivery_notes_btn,
        templates,
      };
    },
    product_group_id: function () {
      return this.$route.params.product_group_id;
    },

    product_groupSidewindowTabs: function () {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("overview"),
          vgi_id: "product_group",
        },
      ]);
    },
  },
  methods: {
    ...mapActionObject(storeNS, product_groupsCatalogActions),
    onProductExportClicked: function () {
      console.log("Product Export");
      this.$router.push({
        ...this.$route,
        query: {
          modal: "product_export",
        },
      });
    },
    onDocumentsClicked: function () {
      console.log("Documents modal");
      this.$router.push({
        ...this.$route,
        query: {
          modal: "document_templates",
        },
      });
    },

    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAddProductsClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_products",
        },
      });
    },

    onAdded: function (payload) {
      console.log("response ", payload, {
        ...payload,
        item: this.selectedProduct_groupDetails,
      });
      this[ActionTypes.ProductGroupProducts.SET.ALL]({
        ...payload,
        item: this.selectedProduct_groupDetails,
      }),
        this.onDialogCancelled();
    },
    onChanged: function (payload) {
      console.log("response ", payload);
      this[ActionTypes.Product_groupDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedProduct_groupDetails,
      });
    },

    onProductsDeleted: function (item) {
      this[ActionTypes.ProductGroupProducts.DELETE.SINGLE]({
        // <-- Dispatch Method
        item,
        product_group_id: this.product_group_id,
      });
    },
    // onTabOptionClicked(value) {
    //   if (value == "documents") {
    //     this.onDocumentsClicked();
    //   } else if (value == "product_export") {
    //     if (this.selectedProduct_groupDetails?.products?.length > 0) {
    //       this.onProductExportClicked();
    //     } else {
    //       NotificationService.showNotification({
    //         text: `At least one Product needs to be in the Product Group`,
    //         timeout: 3000,
    //         type: "error"
    //       });
    //     }
    //   }else if(value=='product_import'){
    //     this.$router.push({
    //       ...this.$route,
    //       query: {
    //         modal: "import_products"
    //       }
    //     });
    //   }
    // },
    onTabOptionClicked(value) {
      switch (value) {
        case "documents":
          openModalRoute2(this, "dtTemplateList", {
            external_id: this.product_group_id,
          });
          break;
        case "product_export":
          if (this.selectedProduct_groupDetails?.products?.length > 0) {
            this.onProductExportClicked();
          } else {
            NotificationService.showNotification({
              text: `At least one Product needs to be in the Product Group`,
              timeout: 3000,
              type: "error",
            });
          }
          break;
        case "product_import":
          this.$router.push({
            ...this.$route,
            query: {
              modal: "import_products",
            },
          });
          break;
        case "print_delivery_note":
          this.$router.push({
            ...this.$route,
            query: {
              modal: "print_delivery_note_modal",
            },
          });
        default:
          // Handle the default case if needed
          break;
      }
    },

    onUpload: async function (payload) {
      console.log("payload", payload);
      this.onDialogCancelled();
      const formData = new FormData();
      formData.append("section", "product_groups");
      formData.append("action", "make_relation_from_xls");
      formData.append("product_group_id", this.product_group_id);
      formData.append("file", payload?.file);

      const res = await ProductGroupsService.makeRelationFromXls(formData);

      if (res.data.error) {
        NotificationService.showNotification({
          text: res.data.details,
          timeout: 5000,
          type: "error",
        });
      } else {
        this[ActionTypes.Product_groupDetails.FETCH.SINGLE]({
          reload: true,
          product_group: { product_group_id: this.product_group_id },
        });
        if (res.data.unmatched_lines && res.data.unmatched_lines.length > 0) {
          this.unmatchedLines = res.data.unmatched_lines;
          this.$router.push({
            ...this.$route,
            query: {
              modal: "show_unmatched_line",
            },
          });
        }
      }
      console.log(res, "::::::::::::");

      //   curl --location 'https://dev.berlin3.com/updatecheck2/label.pl' \
      //   --form 'section="product_groups"' \
      //   --form 'action="make_relation_from_xls"' \
      //   --form 'file=@"file location"' \
      //  --fo,rm 'product_group_id="21"'
    },
    onPrintDelivery: async function (payload) {
      const { domain_tld } = window.HttpClient.getBaseURLObject();

      const { start_date, end_date, booking_template_id } = payload;

      const url = `https://batch.${domain_tld}/${MHTTPCL.clientName}${ACCOUNTING_URL}`;

      //?section=invoices&action=pdf_invoice_batch&type=catalog_order&product_group_id=${this.product_group_id}&start_date=${start_date}&end_date=${end_date}&booking_template_id=${booking_template_id}`

      console.log(url);

      const res = await ProductGroupsService.pdfInvoiceBatch(url, {
        section: "invoices",
        action: "pdf_invoice_batch",
        type: "catalog_order",
        product_group_id: this.product_group_id,
        start_date: start_date,
        end_date: end_date,
        booking_template_id: booking_template_id,
      });

      NotificationService.showNotification({
        text: res.data.result,
        timeout: 5000,
        type: "normal",
      });

      console.log(url, res);
      this.onDialogCancelled();
      // window.open(url,'_blank')
      //{domain_tld },payload,
      //https://batch.berlin3.com/berlin3/accounting.pl?section=invoices&action=pdf_invoice_batch&type=catalog_order&product_group_id=5&start_date=2001-01-1&end_date=2025-01-01&booking_template_id=717
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-product_groups-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 150px);
  }
}
</style>
